const tabs = [
	{
		className: 'header-switch__link-stat',
		title: 'Общая',
		url: 'statistics/general/'
	},
	{
		className: 'header-switch__link-goal',
		title: 'Конверсии',
		url: 'statistics/conversions/'
	},
	{
		className: 'header-switch__link-analytics',
		title: 'Аналитика',
		url: 'statistics/analytics/'
	},
	{
		className: 'header-switch__link-autotrash',
		title: 'Автотреш',
		url: 'statistics/banned/',
		isVisibleWithFlag: true,
		isAddedAutoTrashNumber: true
	}
];

export default tabs;


// WEBPACK FOOTER //
// ./frontend/cabinets/modules/statistics/shared/switch-cfg.js